import { Stack, Typography } from "@mui/material";

export default function IconLabel(props) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={props.gap || "8px"}
      {...props}
    >
      {props.icon || (
        <img
          src={props.src}
          alt=""
          style={{ width: "24px" }}
          {...props.iconProps}
        />
      )}
      {props.text || (
        <Typography variant={props.textVariant || "subtitle1"}>
          {props.label}
        </Typography>
      )}
    </Stack>
  );
}
